import { config } from "@/config";
import { ApiError } from "@/lib/api-client";
import { API_REQUEST_TIMEOUT_MS } from "@/lib/query-constants";

interface ApiEnvelope<T> {
  success: boolean;
  data?: T;
}

export interface VendorInviteValidation {
  clientName: string;
  vendorLabel: string;
  email: string;
  expiresAt: string;
}

export interface VendorInviteAcceptResult {
  clientName: string;
  vendorLabel: string;
  email: string;
}

async function publicFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${config.apiUrl}${path}`, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(init?.headers as Record<string, string> | undefined),
    },
    signal: AbortSignal.timeout(API_REQUEST_TIMEOUT_MS),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const envelope = (body as { error?: { message?: string; code?: string } }).error;
    throw new ApiError(
      res.status,
      envelope?.message ?? `Request failed: ${res.status}`,
      envelope?.code,
    );
  }

  const json = (await res.json()) as ApiEnvelope<T>;
  return json.data as T;
}

export async function validateVendorInvite(token: string): Promise<VendorInviteValidation> {
  const params = new URLSearchParams({ token });
  return publicFetch<VendorInviteValidation>(`/marketplace/vendor-invites/validate?${params}`);
}

export async function acceptVendorInvite(token: string): Promise<VendorInviteAcceptResult> {
  return publicFetch<VendorInviteAcceptResult>("/marketplace/vendor-invites/accept", {
    method: "POST",
    body: JSON.stringify({ token }),
  });
}
